import { render, staticRenderFns } from "./MedCompanyDialog.vue?vue&type=template&id=f15f7d68&scoped=true&"
import script from "./MedCompanyDialog.vue?vue&type=script&lang=js&"
export * from "./MedCompanyDialog.vue?vue&type=script&lang=js&"
import style0 from "./MedCompanyDialog.vue?vue&type=style&index=0&id=f15f7d68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f15f7d68",
  null
  
)

export default component.exports